import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Inicio from '../modulo/componentes/Inicio'
import Principal from '../modulo/componentes/Principal'

const RouterMain = () => {
    return (
     
        <Router>
        <Switch>
            <Route path={"/visor/:sponsor/:nombrepdf"} component={Principal} />
            <Route path={"/"} component={Inicio} />
        </Switch>
    </Router>
    )
}

export default RouterMain
